import api from "../config/api";
import { ServiceReturn } from "../types/ServiceResponse";

export interface DashboardPayload {
  queueId?: string;
  from?: string;
  to?: string;
};

export interface DashboardSummary {
  organizations: number;
  queues: number;
  contacts: number;
  services: number;
  messages: number;
  attendants: number;
  averageWaitingSeconds: number;
  averageHandlingSeconds: number;
};

export interface DashboardRatingSummary {
  completed: number;
  declined: number;
  averageScore?: number;
  successRate?: number;
};

export interface DashboardStatusTotal {
  status: string;
  total: number;
};

export interface DashboardDailyServiceTotal {
  date: string;
  created: number;
  finalized: number;
};

export interface DashboardDailyQueueServiceTotal {
  date: string;
  queueId: string;
  queueName: string;
  organizationId: string;
  organizationName: string;
  total: number;
};

export interface DashboardDailyMessageTotal {
  date: string;
  inbound: number;
  outbound: number;
  bot: number;
  total: number;
};

export interface DashboardQueueMetric {
  id: string;
  name: string;
  organizationId: string;
  organizationName: string;
  services: number;
  waiting: number;
  inProgress: number;
  finalized: number;
  averageWaitingSeconds: number;
  averageHandlingSeconds: number;
};

export interface DashboardAttendantMetric {
  id: string;
  name: string;
  email: string;
  organizationId: string;
  organizationName: string;
  queues: Array<string>;
  assignedServices: number;
  finalizedServices: number;
  averageHandlingSeconds: number;
  averageScore?: number;
  successRate?: number;
  classification: string;
};

export interface DashboardData {
  scope: {
    type: string;
    organizationId?: string;
    queueIds?: Array<string>;
    from: string;
    to: string;
  };
  summary: DashboardSummary;
  ratings: DashboardRatingSummary;
  servicesByStatus: Array<DashboardStatusTotal>;
  servicesByDay: Array<DashboardDailyServiceTotal>;
  servicesByQueueDay: Array<DashboardDailyQueueServiceTotal>;
  messagesByDay: Array<DashboardDailyMessageTotal>;
  queues: Array<DashboardQueueMetric>;
  attendants: Array<DashboardAttendantMetric>;
};

export const getDashboard = async ( params: DashboardPayload, token?: string ): Promise<ServiceReturn<DashboardData>> => {
  try {
    const { data } = await api.get("/dashboard", {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
      params,
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
